import React from 'react';
import {
  Breadcrumb, Button, Input, Card, Table, Spin, Row, Col
} from 'antd';
import { useTranslation } from 'react-i18next';
import { faMicrochip, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FallOutlined, FilterOutlined, PieChartOutlined, PlusOutlined, RiseOutlined, SearchOutlined } from '@ant-design/icons';
import Chart from 'react-apexcharts';
import {
  ResponsiveContainer,
} from 'recharts';

import MainLayout from '@common/layouts/MainLayout';
import withAuth from '@common/hocs/withAuth';
import CenteredContent from '@common/components/ui/CenteredContent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
 
import useMetricsDetail from './useMetricsDetail';
import styles from './MetricsDetail.module.less';

function MetricsDetail() {

  const { t } = useTranslation();
  const {
    loading,
    dataSource,
    columns,
    optionsGraphG1,
    seriesGraphG1,
    optionsGraphG2,
    seriesGraphG2,
  } = useMetricsDetail();

  return (
    <MainLayout applyWidthLimit>
       {loading ? (
            <>
              <CenteredContent>
                <Spin tip={t('views.device_graphics.loading_data_graphs')} />
              </CenteredContent>
            </>
          ) : (
            <> 
              <Row>
                <Col span={24} style={{ padding: '.95rem' }}>
                  <Card style={{ width: '100%' }}>
                    <Row>
                      <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                        <Row className="miga_title">
                          <PieChartOutlined  style={{fontSize:25}}/>Metricas
                        </Row>
                        <Row style={{ fontSize: '14px', color: '#8c8c8c' }}>
                          <Breadcrumb className={styles.date_wrapper}>
                            <Breadcrumb.Item className={styles.breadcrumb}>
                              <Link to="/">{t('menu_items.main.home')}</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item className={styles.breadcrumb}>
                              <Link to="/clientes">{t('views.users.breadcrumb.clients')}</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item className={styles.breadcrumb}>
                              A000001
                            </Breadcrumb.Item>
                          </Breadcrumb>
                        </Row>
                      </Col>
                      <Col xs={24} sm={24} md={8} lg={8} xl={8} className="text-right">

                        <Button type="primary" style={{ float: 'right', padding: '.5rem 1rem 1.8rem', marginLeft:5, width: '45%' }}>
                          <PlusOutlined />
                          Generar reporte
                        </Button>

                        <Button style={{ float: 'right', padding: '.5rem 1rem 1.8rem', marginRight: 5, width: '45%' }}>
                          <FilterOutlined />
                          Filtros
                        </Button>
                      </Col>
                    </Row> 
                  </Card>
                </Col>
              </Row>

              <Row>
                <Col span={24} style={{ padding: '.95rem' }}>
                  <Card style={{ width: '100%' }}>

                    <Row>
                      <Col span={24}>
                        <span className='miga_title' style={{fontSize:18}}>Resumen</span> <span className={styles.cardText}>Total acumulado</span> 
                      </Col>
                    </Row>

                    <Row>
                      
                      <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                        <div className={styles.cardCustom}>
                          <RiseOutlined  style={{fontSize:25, color:'#ff812e'}} /> <span className='miga_title'>420.000</span> <span className={styles.cardText}>kwh</span><br></br>
                          <span>Energía solar generada</span>
                        </div>
                      </Col>

                      <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                      <div className={styles.cardCustom}>
                          <FallOutlined  style={{fontSize:25, color:'#39587d'}} /> <span className='miga_title'>284.430</span> <span className={styles.cardText}>kwh</span><br></br>
                          <span>Energía Consumida</span>
                        </div>
                      </Col>

                      <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                        <div className={styles.cardCustom}>
                          <RiseOutlined  style={{fontSize:25, color:'#ff812e'}} /> <span className='miga_title'>135.570</span> <span className={styles.cardText}>kwh</span><br></br>
                          <span>Energía solar reservada</span>
                        </div>
                      </Col>
                      
                    </Row>

                    <Row>
                      
                      <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                        <div className={styles.cardCustom}>
                          <RiseOutlined  style={{fontSize:25, color:'#ff812e'}} /> <span className='miga_title'>753.400.403</span> <span className={styles.cardText}>cop</span><br></br>
                          <span>Ganancias generadas</span>
                        </div>
                      </Col>

                      <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                      <div className={styles.cardCustom}>
                          <span className='miga_title'>12.78</span> <span className={styles.cardText}>ton</span><br></br>
                          <span>Total C02 reducido</span>
                        </div>
                      </Col>

                      <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                        <div className={styles.cardCustom}>
                          <span className='miga_title'>12</span> <span className={styles.cardText}></span><br></br>
                          <span>Total dispositivos </span>
                        </div>
                      </Col>
                      
                    </Row>
                  </Card>
                </Col>
              </Row>

              <Row>
                <Col span={24} style={{ padding: '.95rem' }}>
                  <Card style={{ width: '100%' }}>

                    <Row>
                      <Col span={24}>
                        <span className='miga_title' style={{fontSize:18}}>Tabla de liquidaciones</span> 
                      </Col>
                    </Row> 

                    <Row> 
                      <Col span={24}>
                        <Table dataSource={dataSource} columns={columns} width={'100%'} />
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>

              <Row>
                <Col span={12} style={{ padding: '.95rem' }}>
                  <Card style={{ width: '100%' }}>

                    <Row>
                      <Col span={24}>
                        <span className='miga_title' style={{fontSize:18}}>Energía solar generada VS consumida</span> 
                      </Col>
                    </Row> 

                    <Row> 
                      <Col span={24}>
                        <Chart
                            className="container-graph-third"
                            options={optionsGraphG1}
                            series={seriesGraphG1}
                            height={370}
                            width="100%"
                            type="donut"
                          />
                      </Col>
                    </Row>
                  </Card>
                </Col>

                <Col span={12} style={{ padding: '.95rem' }}>
                  <Card style={{ width: '100%' }}>

                    <Row>
                      <Col span={24}>
                        <span className='miga_title' style={{fontSize:18}}>Energía solar generada</span> 
                      </Col>
                    </Row> 

                    <Row> 
                      <Col span={24}>
                        <Chart
                          className="container-graph-third"
                          options={optionsGraphG2}
                          series={seriesGraphG2}
                          width="100%"
                          type="area"
                        />
                      </Col>
                    </Row>
                  </Card>
                </Col>

              </Row>
            </>
          )
      }
    </MainLayout>
  );

}

export default withAuth(MetricsDetail);
